import React from 'react';
import TableSort from '../../../components/TableSort';
import { useDispatch, useSelector } from 'react-redux';
import { useWindowSize } from '../../../hook/useWindowSize';
import TitlePage from '../../../components/TitlePage';
import { Container } from './styles';
import ModalVeiculo from './NovoVeiculo';
import { ApplicationState } from '../../../store';
import { loadRequest } from '../../../store/ducks/listarVeiculos/actions';
import { IListarVeiculos } from '../../../store/ducks/listarVeiculos/types';
import { ColumnType } from 'antd/lib/table';
import TextTable from '../../../components/TextTable';
import Filter from './Filter';
import Refresh from '../../../components/Refresh';
import { Button, Dropdown, Menu, Popconfirm, notification } from 'antd';
import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';
import { excluiVeiculoPortal } from './services/cadVeiculoServices';
import ModalAddBlackList from './addBlackList';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const { width }: any = useWindowSize();
  const veiculos = useSelector((state: ApplicationState) => state.ListarVeiculos.data);
  const loading = useSelector((state: ApplicationState) => state.ListarVeiculos.loading);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const filter = useSelector((state: ApplicationState) => state.ListarVeiculos.filter);
  const pagination = useSelector((state: ApplicationState) => state.ListarVeiculos.pagination);

  const confirm = async (codVeiculo: number) => {
    try {
      await excluiVeiculoPortal.excluiVeiculoPortal(codVeiculo, inscricaoAtiva).then((res) => {
        notification.success({
          message: 'Veículo removido com sucesso!',
          placement: 'bottomRight',
        });
        dispatch(loadRequest(inscricaoAtiva, filter, pagination));
      });
    } catch (error: any) {
      if (error.response.data.Erro) {
        return notification.error({
          message: error.response.data.Erro,
          placement: 'bottomRight',
        });
      }
      return notification.error({
        message: 'Não foi possível remover o veículo, tente novamente ou contate o suporte.',
        placement: 'bottomRight',
      });
    }
  };

  const columns: ColumnType<IListarVeiculos>[] = [
    {
      title: 'Placa',
      dataIndex: 'placa',
      key: 'placa',
      align: 'center',
      width: 120,
      render: (text: string) => {
        return <TextTable>{text}</TextTable>;
      },
    },

    {
      title: 'Ano do veículo',
      dataIndex: 'ano',
      key: 'ano',
      align: 'center',
      width: 300,
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : 'Não informado';
      },
    },

    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 50,
      fixed: 'right',
      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item data-cy="btn-excluir" className="themeOrdemCargaAcao">
              <Popconfirm
                title="Tem certeza que deseja remover esse veículo?"
                onConfirm={() => confirm(record?.codVeiculo)}
                okText="Sim"
                cancelText="Não"
              >
                <Button icon={<DeleteOutlined />}>Excluir</Button>
              </Popconfirm>
            </Menu.Item>
            <Menu.Item className="themeOrdemCargaAcao">
              <ModalAddBlackList record={record} />
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button
              data-cy="btn-acoes"
              type="text"
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <Refresh loadRequest={() => dispatch(loadRequest(inscricaoAtiva, filter, pagination))} />
      <Filter />

      <Container>
        <TitlePage>
          Cadastro de veículos
          <div className="box">
            <ModalVeiculo />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 1200 }}
            size={'large'}
            pagination={pagination}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(loadRequest(inscricaoAtiva, filter, pagination));
            }}
            className="table"
            dataSource={veiculos}
            loading={loading}
          />
        )}
      </Container>
    </>
  );
};

export default App;
